import config from '@/api/config'

let subUrl = '/webview/guard'

export default {
  init: {
    url: function ({typeID}) {
      let queryString = ''
      if (typeID) {
        queryString = '?typeID=' + typeID
      }
      return config.baseUrl + config.version2 + subUrl + '/init' +
        queryString
    }
  },
  sortOutlets: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/sortOutlets'
    }
  }
}
